// extracted by mini-css-extract-plugin
export var content = "News-module--content--7678b";
export var ctaWrapper = "News-module--ctaWrapper--f6f72";
export var wrapper = "News-module--wrapper--23f13";